import { IPartnerGroupInfo } from 'legacy/lut/classes/models/partner360/IPartnerGroup'

import { IPartnerGroupAdditionalInfo } from '../../models/IPartnerGroupAdditionalInfo'
import { fetchMembersCountByPartnerGroup } from '../../ui/meetingLogistics/mainInfo/api/fetchMembersCountByPartnerGroup'

export const getPartnerGroupData = async (
  groupData: IPartnerGroupInfo
): Promise<IPartnerGroupAdditionalInfo> => {
  const {
    GroupName,
    GroupId,
    HPSponsorName,
    MainHQPartnerName,
    MainHQPartnerId,
    PartnerId,
    LocationId,
  } = groupData
  const membersCount = await fetchMembersCountByPartnerGroup(groupData.GroupId, false)
  return {
    membersCount,
    groupId: GroupId,
    groupName: GroupName,
    partnerId: PartnerId,
    mainHqPartnerId: MainHQPartnerId,
    mainHqPartnerName: MainHQPartnerName,
    hpSponsorName: HPSponsorName,
    locationId: LocationId,
    uid: groupData.UID,
  }
}
